<template>
  <div>
    <h6 class="booking-details-title">RO Produs </h6>
    <b-card bg-variant="light">
      <b-card-text>
        Costuri de anulare in cazul neinceperii calatoriei : pana la 21.000 RON / calatorie<br>
        Intreruperea calatoriei: pana la 4.500 RON/ individual<br>
        Costuri de spitalizare si tratamente medicale de urgenta: pana la 130.000 RON/individual<br>
        Aeroambulanta / repatriere in caz de necesitate medicala sau dupa 3 zile de spitalizare: pana la 130.000 RON/individual<br>
        Bilet de avion de intoarcere: pana la 4.500 RON/ individual<br>
        Compensatia in caz de deces, invaliditate: pana la 45.000 RON/ eveniment<br>
        Costuri de cautare si salvare: pana la 20.000 RON /eveniment<br>
        Asigurarea bagajelor de calatorie pentru furt, jaf : pana la 4.500 RON /individual<br>
        Costuri de despagubire pentru deteriorarea si pierderea bagajelor de calatorie: pana la 450 RON /individual<br>
        Costuri pentru achizitii de stricta necesitate, in cazul livrarii cu intarziere a bagajelor la destinatia de vacanta (12h): pana la 450 RON/ individual<br>
        Pentru informatiile complete privind produsul ales, solicitati pliantul de prezentare si C.G.A
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'InsuranceItemInfo',
  props: ['item']
}
</script>
